import React from 'react';
import { BellIcon, UserIcon, SearchIcon } from 'lucide-react';
import { cn } from '../utils';
type HeaderProps = {
  title: string;
};
export function Header({
  title
}: HeaderProps) {
  return <header className="bg-background border-b border-border px-4 py-3 flex items-center justify-between" data-id="element-1637">
      <div className="flex items-center space-x-4" data-id="element-1638">
        <div className="flex items-center gap-2" data-id="element-1639">
          <svg className={cn('fill-current text-foreground')} height={32} viewBox="0 0 48 48" width={32} xmlns="http://www.w3.org/2000/svg" data-id="element-1640">
            <path d="M32.678 33.906h-.11c-7.42 0-13.314-5.784-13.314-13.096S25.147 7.713 32.568 7.713h.11c7.42 0 13.314 5.785 13.314 13.097 0 7.312-5.893 13.096-13.314 13.096Zm-.11-8.185h.11c2.673 0 4.856-2.292 4.856-4.911 0-2.674-2.183-4.911-4.856-4.911h-.11c-2.673 0-4.856 2.182-4.856 4.91 0 2.674 2.183 4.912 4.856 4.912ZM4.256 46.456H1.964v-7.912h1.855c2.783 0 4.966-1.855 4.966-5.075V8.26h8.185v25.92c0 8.021-5.239 12.277-12.714 12.277Z" data-id="element-1641" />
          </svg>
        </div>
        <div className="hidden items-center text-sm text-muted-foreground sm:flex" data-id="element-1642">
          <span className="font-normal" data-id="element-1643">Dashboard</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-right mx-1 h-4 w-4" data-id="element-1644">
            <path d="m9 18 6-6-6-6" data-id="element-1645"></path>
          </svg>
          <span className="font-medium text-foreground" data-id="element-1646">{title}</span>
        </div>
      </div>
      <div className="flex items-center space-x-4" data-id="element-1647">
        <div className="relative" data-id="element-1648">
          <input type="text" placeholder="Search..." className="pl-9 pr-4 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary bg-input text-foreground/70 text-sm" data-id="element-1649" />
          <SearchIcon className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" data-id="element-1650" />
        </div>
        <button className="relative p-2 rounded-full hover:bg-muted" data-id="element-1651">
          <BellIcon className="h-5 w-5 text-muted-foreground" data-id="element-1652" />
          <span className="absolute top-0 right-0 h-4 w-4 bg-success text-white text-xs flex items-center justify-center rounded-full" data-id="element-1653">
            5
          </span>
        </button>
        <button className="p-2 rounded-full hover:bg-muted" data-id="element-1654">
          <UserIcon className="h-5 w-5 text-muted-foreground" data-id="element-1655" />
        </button>
      </div>
    </header>;
}